<template>
   <div class="columns card-item">
      <div :class="'column-2 item-badge item-color-'+group">&nbsp;</div>
      <div class="column-10 card-info">
         <span style="float:left;" class="licenseNo">{{item.licenseNo}}</span>
         <span style="float:right;" v-if="page==='estimate' && item.status !== 'queueWorkshop'">{{displayDate(item.createdAt)}}</span>
          <span v-if="item.jobType"> ({{item.jobType}})</span>
          <span v-if="item.trackDate" class="countdown">
              <span v-if="aging(item.trackDate) <= 2" class="tag is-danger">{{aging(item.trackDate)}}</span>
              <span v-else-if="aging(item.trackDate) <= 4" class="tag is-warning">{{aging(item.trackDate)}}</span>
              <span v-else class="tag is-info">{{aging(item.trackDate)}}</span>
          </span><br>
          <span class="editBtn" @click="modalActive = 'is-active'" v-show="item.status !== 'start' && item.status !== 'waitInsurance' && item.status !== 'waitCustomer'">
            <span v-if="estimatePosition.indexOf(profile.position) >= 0">
              <i class="fas fa-edit"></i>
            </span>
          </span>
          <span class="carBtn">
            <span v-show="carOnService" @click="setCarOnService(false)">
              <i class="fas fa-car fa-2x" style="color:green;"></i>
            </span>
            <span v-show="!carOnService" @click="setCarOnService(true)">
              <i class="fas fa-car fa-2x" style="color:#eeeeee;"></i>
            </span>
          </span>
          <span v-show="item.status === 'start' || item.status === 'waitInsurance' || item.status === 'waitCustomer'">{{(item.Insurrance !== 'other' ? item.Insurrance : item.insurranceOther)}}<br></span>
          <span>{{item.Model}} - {{item.carColor}} <span class="notScan">{{ item.userId === -1 ? '(-1)' : ''}}</span></span><br>
         <span v-show="item.status !== 'start' && item.status !== 'waitInsurance' && item.status !== 'waitCustomer'">นัด {{item.trackDate}}<br></span>
         <span>{{item.staffEstimate}}</span>
      </div>

      <div :class="'modal ' + modalActive">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">แก้ไขข้อมูล BP</p>
            <button class="delete" aria-label="close" @click="modalActive = ''"></button>
          </header>
          <section class="modal-card-body">
            <div class="field">
              <label class="label">วันที่นัดลูกค้า</label>
              <div class="control">
                <input class="input" type="text" placeholder="วันที่นัดลูกค้า" v-model="item.expectedDate"><br>
                <span class="note">DD/MM/2020</span>
              </div>
            </div>
            <div class="field">
              <label class="label">วันที่นัดช่าง</label>
              <div class="control">
                <input class="input" type="text" placeholder="วันที่นัดช่าง" v-model="item.trackDate"><br>
                <span class="note">DD/MM/2020</span>
              </div>
            </div>
            <div class="field">
              <label class="label">เลขทะเบียน <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="text" placeholder="เลขทะเบียน" v-model="item.licenseNo">
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" v-if="!startSave" @click="saveCard">บันทึก</button>
            <button class="button is-success" v-else disabled>กำลังบันทึก...</button>
            <button class="button" @click="modalActive = ''">ยกเลิก</button>
          </footer>
        </div>
      </div>

   </div>
</template>
<script>
export default {
  name: 'card',
  props: {
    group: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    page: {
      type: String,
      required: false
    },
    profile: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    modalActive: '',
    startSave: false,
    carOnService: null,
    estimatePosition: ['General Manager', 'Service Manager', 'Estimator Controller', 'Estimator', 'Administration Estimator']
  }),
  mounted () {
    console.log(this.item)
    this.carOnService = this.item.carOnService
  },
  methods: {
    aging (trackdate) {
      trackdate = trackdate.split('/')
      const d = new Date(trackdate[2], trackdate[1] - 1, trackdate[0])
      const dnow = new Date()
      return Math.ceil((d.getTime() - dnow.getTime()) / (1000 * 60 * 60 * 24))
    },
    async setCarOnService (carOnService) {
      let params = {
        carId: this.item.id,
        carOnService: carOnService
      }
      await this.$axios
        .post(`${this.$apiUrl}setCarOnService`, params)
        .then(response => {
          this.carOnService = carOnService
        })
    },
    async saveCard () {
      this.startSave = true
      let params = {
        carId: this.item.id,
        runNo: this.item.runNo,
        jobType: this.item.jobType,
        expectedDate: this.item.expectedDate,
        trackDate: this.item.trackDate,
        unCloseReason: ''
      }
      await this.$axios
        .post(`${this.$apiUrl}updateBPInfo`, params)
        .then(response => {
          this.startSave = false
          this.modalActive = ''
        })
    }
  }
}
</script>
<style scoped>
.note {
  padding-left: 10px;
  color: #666;
  font-size: 13px;
}
.editBtn {
  position: absolute;
  right: 10px;
  bottom: 5px;
  cursor: pointer;
}
.carBtn {
  position: absolute;
  right: 35px;
  bottom: 3px;
  cursor: pointer;
}
.notScan {
  color: #fd0000;
}
.insurance {
  overflow: hidden;
}
.countdown {
  position: absolute;
  top: 0;
  right: 7px;
}
.licenseNo {
  font-size: 12px;
  font-weight: bold;
}
.card-info {
  text-align: left;
}
.card-item {
  position: relative;
  font-size: 12px;
}
.item-badge {
  width: 10px;
  height: 85px;
  padding: 0;
  margin: -3px 4px;
}
.item-color-1 {
  color: #fff !important;
  background-color: #1100fe !important;
}
.item-color-2 {
  color: #fff !important;
  background-color: #fd0000 !important;
}
.item-color-3 {
  color: #fff !important;
  background-color: #f405fd !important;
}
.item-color-4 {
  color: #fff !important;
  background-color: #6d4ba5 !important;
}
.item-color-5 {
  color: #000 !important;
  background-color: #e3b8b1 !important;
}
.item-color-6 {
  color: #000 !important;
  background-color: #02fefd !important;
}
.item-color-7 {
  color: #000 !important;
  background-color: #feff05 !important;
}
.item-color-8 {
  color: #fff !important;
  background-color: #01b753 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BP/card.vue